import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Output,
} from '@angular/core';

@Component({
  selector: 'acl-installation-delivery-status-v1',
  standalone: false,
  templateUrl: './installation-delivery-status-v1.component.html',
  styleUrl: './installation-delivery-status-v1.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationDeliveryStatusV1Component {
  // Received view switch according to page
  readonly switchView = input<string>('');
  readonly routeName = input<string>('');
  readonly canShowButton = input<boolean>(false);
  readonly shouldDisableForm = input<boolean>(false);

  @Output() readonly addInstallation = new EventEmitter();

  menuItemClick(childUrl: string): void {
    this.addInstallation.emit(childUrl);
  }
}
